import { Config, SessionStorageUtils } from '../../utils';
import { EntryPoint, TabTypePropDefault } from '../../models';
import { ActiveProduct } from './actionTypes';

const getInitialState = () => {
    const entryPoint = Config.get('entryPoint') || EntryPoint.HOME;
    const lastActiveTab = SessionStorageUtils.getJSON('lastActiveTab') || TabTypePropDefault;
    const activeProduct = entryPoint === EntryPoint.HOME ? lastActiveTab : entryPoint;
    return { activeProduct, isPrime: false };
};

const setProduct = (state, activeProduct) => {
    SessionStorageUtils.setJSON('lastActiveTab', activeProduct);
    return { ...state, activeProduct };
};

export default function(state = getInitialState(), action) {
    if (action.type === ActiveProduct.SET) {
        return setProduct(state, action.activeProduct);
    } else if (action.type === ActiveProduct.ISPRIME) {
        return {
            ...state,
            isPrime: action.payload,
        };
    }
    return state;
}
